import { defineEntity, lifecycle, custom } from './_helpers.js';

export default defineEntity('dpiaAssessment', {
    // lifecycle so the event-trigger bridge can start the approval workflow
    submitted: lifecycle(),
    completed: custom({ scope: 'state' }),
});
